import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Titre-dev": "Front-end developer",
      "description": "I have been passionate about informatics ever since I was a kid. I discovered web development in high school and I loved it right away. That's why I'm here today to make the website of your dreams.",
      "Diplomas": "My Degrees :",
      "diploma1Type": "Professional Baccalaureate",
      "diploma1Specialty": "in Digital Systems, IT and Networks",
      "diploma2Type": "Web Developer Certification",
      "diploma2Specialty": "Specialty in front-end",
      "projetcs": "My projects",
      "SkillsTitle": "My skills",
      "website": "Website",
      "websitetext": "Whether it's a web application or a showcase website, I can create it for you.",
      "seo-text": "Do you want to increase your visibility with effective SEO? I will implement tailored SEO strategies to help you gain maximum exposure.",
      "accessibility": "accessibility",
      "accessibility-text": "Your website will be accessible to everyone, because the web should be available to all.",
      "ContactTitle": "Want to talk about an idea?",
      "formTitle": "Do you prefer a form ?",
      "Name-title": "Your name or your Company name",
      "argentbank-txt": "Development of a banking application using React and Redux. Management of user login and data modification.",
      "724event-txt": "I take over existing codebases to identify and resolve any present bugs, ensuring smoother performance and improved functionality.",
      "kasa-txt": "Set up a web application with React, managing components and the user interface.",
      "belperf-txt": "Creation of a showcase website for Belperf Auto garage, including the addition of a Google Maps integration and a contact form.",
    }
  },
  fr: {
    translation: {
      "Titre-dev": "Développeur front-end",
      "description": "Passioné d'informatique depuis le plus jeune âge, c'est en arrivant au lycée que j'ai pu découvrir le développement web qui m'a directement passionné, c'est pour ça qu'aujourd'hui je suis là pour réaliser votre site de rêve.",
      "Diplomas": "Mes Diplômes :",
      "diploma1Type": "Bac Pro",
      "diploma1Specialty": "Systèmes Numériques, Informatique et Réseaux",
      "diploma2Type": "Certification Développeur Web",
      "diploma2Specialty": "Spécialité en développement frond-end",
      "projetcs": "Mes projets",
      "SkillsTitle": "Mes compétences",
      "website": "Site Web",
      "websitetext": "Que ce soit une application web ou un site vitrine je peux vous le réaliser",
      "seo-text": "Vous souhaitez améliorer votre visibilité grâce à un bon référencement ? Je mettrai en place un SEO adapté pour vous faire connaître au mieux.",
      "accessibility": "Accessibilité",
      "accessibility-text": "Votre site web sera accessible à toutes et à tous, car le web doit être accessible à tout le monde.",
      "ContactTitle": "Envie de me parler d'une idée ?",
      "formTitle": "Vous préférez un formulaire ?",
      "Name-title": "Votre nom ou votre nom d'entreprise",
      "Subject": "Sujet",
      "argentbank-txt": "Développement d’une application bancaire en utilisant React et Redux. Gestion de la connexion et des données utilisateur.",
      "724event-txt": "Reprise d'un code existant pour détecter et corriger les bugs présents.",
      "kasa-txt": "Mise en place d’une application web avec React, gestion des composants et de l’interface utilisateur.",
      "belperf-txt": "Création d'un site web vitrine pour le garage Belperf Auto, avec l'ajout d'une carte Google Maps et d'un formulaire de contact.",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr", // Langue par défaut
    fallbackLng: "en", // Langue de secours si une traduction est manquante
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;